import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { getFallbackMakeLogoImage } from "../../../utils/carLogo/getFallbackMakeLogoImage";
import { getExpiresIn } from "../../../utils/helpers/getExpiresIn";
import { getRequestStateLabel } from "../../../utils/helpers/getRequestStateLabel";
import StorageIconSVG from "../../../assets/icons/svg/StorageIconSVG";
import ArrowNextIconSVG from "../../../assets/icons/svg/ArrowNextIconSVG";

const RequestTableRowHomePage = ({ carRequest, onSelect }) => {
    const makeName = carRequest.Make.name || "N/A";
    const modelName = carRequest?.Generation?.name || "N/A";
    const stateLabel = getRequestStateLabel(carRequest?.state);

    const logo = getFallbackMakeLogoImage(makeName);
    const { text: expiresInText, hoursLeft } = getExpiresIn(carRequest?.createdAt);

    return (
        <TableRow hover onClick={onSelect} sx={{ cursor: "pointer" }}>
            <TableCell sx={styles.logoCell}>
                <div style={styles.logoContainer}>
                    <img src={logo} alt={makeName || "logo"} style={styles.logoImage} />
                </div>
            </TableCell>
            <TableCell sx={styles.defaultTextStyle}>
                <span>{makeName} {modelName}</span>
            </TableCell>
            <TableCell
                sx={{
                    ...styles.defaultTextStyle,
                    color: hoursLeft < 5 ? "red" : "black",
                }}
            >
                {expiresInText}
            </TableCell>
            <TableCell sx={styles.defaultTextStyle}>
                <div style={styles.stateBadge(carRequest?.state)}>
                    {stateLabel}
                </div>
                {carRequest?.title || "Nema naslova"}
            </TableCell>
            <TableCell sx={styles.defaultTextStyle}>
                {carRequest?.description || "Nema opisa"}
            </TableCell>
            <TableCell>
                <StorageIconSVG style={styles.iconSize} />
            </TableCell>
            <TableCell>
                <ArrowNextIconSVG style={styles.iconSize} />
            </TableCell>
        </TableRow>
    );
};

export default RequestTableRowHomePage;

const styles = {
    logoCell: {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        color: "black",
    },
    logoContainer: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    logoImage: {
        width: 48,
        height: 48,
        border: "1px solid rgba(203, 213, 225, 1)",
        borderRadius: 8,
        backgroundColor: "rgba(243, 244, 246, 1)",
        objectFit: "contain",
    },
    defaultTextStyle: {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        color: "black",
    },
    stateBadge: (state) => ({
        padding: "4px 10px",
        borderRadius: "999px",
        backgroundColor: state === 3 ? "red" : "green",
        color: "white",
        fontWeight: 600,
        fontSize: "12px",
        whiteSpace: "nowrap",
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: 150,
    }),
    iconSize: {
        width: 24,
        height: 24,
    },
};
